import React from 'react';
import { Helmet } from 'react-helmet';

import { ReactNode } from 'react';

type PageProps = {
  className?: string;
  title?: string;
  children: ReactNode;
};

export default function Page(props: PageProps) {
  const { className, children, title } = props;

  return (
    <div className={className}>
      <Helmet>
        <title>{title || null}</title>
      </Helmet>
      {children}
    </div>
  );
}
